"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleImage = consoleImage;
exports.createPoster = createPoster;
const tslib_1 = require("tslib");
const html2canvas_1 = tslib_1.__importDefault(require("html2canvas"));
const utils_1 = require("../utils");
require("./index.less");
function consoleImage(url) {
    if (process.env.NODE_ENV === 'development') {
        console.log(`%c sup?`, `
          font-size: 1px;
          padding: 200px;
          background-image: url(${url});
          background-repeat: no-repeat;
          background-size: contain;
          color: transparent;
        `);
    }
}
/**
 * 创建海报
 */
async function createPoster({ qrCode, uid, nick, avatar, poster }) {
    const nickString = `${nick} (${(0, utils_1.hideStr)((uid || "").toString(), 3)})`;
    const html = `
        <div class="box">
            <div class="avatar-box">
                <img src="${avatar}" class="avatar">
                <div class="nick">${nickString}</div>
            </div>
            <img src="${qrCode}" class="qr-code">
            <img src="${poster}" class="poster">
        </div>
    `;
    const box = document.createElement('div');
    box.id = 'poster-1kqtfgukiy';
    box.innerHTML = html;
    document.body.appendChild(box);
    console.log('海报元素已添加到页面22');
    await new Promise((res) => {
        setTimeout(() => {
            console.log('海报元素已添加到页面32');
            res(true);
        });
    });
    try {
        console.log('开始生成海报');
        const canvas = await (0, html2canvas_1.default)(box.querySelector('.box'), {
            useCORS: true,
            backgroundColor: null,
            logging: false
        });
        console.log('海报生成完成');
        //关闭抗锯齿
        const context = canvas.getContext('2d');
        if (!context) {
            throw new Error('无法获取canvas上下文');
        }
        console.log('生成海报前1');
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        console.log('生成海报前2');
        const pic = await canvas.toDataURL('image/png', .7);
        console.log('生成海报后');
        console.log(pic);
        return pic;
    }
    catch (e) {
        console.error('生成海报失败', e);
        console.error(e);
        throw new Error('生成海报失败，请稍后再试');
    }
    finally {
        // 移除海报元素
        box.remove();
    }
}
//# sourceMappingURL=data:application/json;base64,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